import MaintenancePage from '@/pages/manufacturing/maintenance/page';

export default function MaintenanceMWOWrapper() {
  return <MaintenancePage initialTab="workorders" />;
}